"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const appliances = [{
  id: 1,
  name: "French Door Refrigerators",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1418843/img/french_door_refrigerator_steel.png"
}, {
  id: 2,
  name: "Front Load Washers and Dryers",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1418843/img/front_load_washer_white.png"
}, {
  id: 3,
  name: "Electric and Gas Range Stoves",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1418843/img/gas_range_stove_black.png"
}, {
  id: 4,
  name: "Smart Dishwashers",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1418843/img/builtin_dishwasher_stainless.png"
}, {
  id: 5,
  name: "Fast local delivery and installation",
  image: "https://smartbuyappliance.com/wp-content/uploads/2025/10/modern_kitchen_appliances_background.webp"
}, {
  id: 6,
  name: "Electric and Gas Dryers",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1418843/img/electric_dryer_white.png"
}];
export default function ExploreOurRange() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.15
  });
  return <section className="bg-background py-16 px-6">
      <div className="container mx-auto max-w-7xl">
        <h2 className="font-display text-4xl font-bold text-foreground text-center mb-3">
          Explore Our Range
        </h2>
        <p className="text-center text-foreground/70 text-lg mb-12 max-w-2xl mx-auto">
          Quality appliances for homes in Raleigh, Durham, and surrounding NC areas
        </p>
        
        <div ref={ref} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {appliances.map((appliance, i) => <div key={appliance.id} data-index={i} className={`
                group relative overflow-hidden rounded-lg bg-muted shadow-soft
                transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)]
                hover:-translate-y-2.5 hover:shadow-medium hover:scale-[1.05]
                ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-2.5"}
              `} style={{
          transitionDelay: isVisible ? `${i * 100}ms` : "0ms"
        }}>
              <div className="aspect-square w-full overflow-hidden bg-background/50">
                <img src={appliance.image} alt={`${appliance.name} - Available in Raleigh NC`} className="h-full w-full object-cover transition-transform duration-[var(--duration-medium)] ease-[var(--ease-out-back)] group-hover:scale-105" />
              </div>
              <div className="p-4 text-center">
                <h3 className="font-display text-lg font-semibold text-foreground">
                  {appliance.name}
                </h3>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}